import React from 'react';
import Icon from '../../../components/AppIcon';

const YesterdayCompletionSection = ({ yesterdayCompletions, onYesterdayToggle }) => {
  const core4Areas = [
    {
      key: 'faith',
      label: 'Faith',
      icon: 'Heart',
      color: 'text-purple-600',
      bgColor: 'bg-purple-100',
      activeBg: 'bg-purple-600'
    },
    {
      key: 'family',
      label: 'Family',
      icon: 'Users',
      color: 'text-blue-600',
      bgColor: 'bg-blue-100',
      activeBg: 'bg-blue-600'
    },
    {
      key: 'finances',
      label: 'Finances',
      icon: 'DollarSign',
      color: 'text-green-600',
      bgColor: 'bg-green-100',
      activeBg: 'bg-green-600'
    },
    {
      key: 'fitness',
      label: 'Fitness',
      icon: 'Dumbbell',
      color: 'text-orange-600',
      bgColor: 'bg-orange-100',
      activeBg: 'bg-orange-600'
    }
  ];

  const completedCount = Object.values(yesterdayCompletions)?.filter(Boolean)?.length;
  const yesterdayDate = new Date();
  yesterdayDate?.setDate(yesterdayDate?.getDate() - 1);

  return (
    <div className="bg-card border border-border rounded-lg shadow-gentle p-6 mb-6">
      {/* Section Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-secondary rounded-lg">
            <Icon name="CheckCircle" size={20} color="white" />
          </div>
          <div>
            <h3 className="text-lg font-heading font-semibold text-foreground">
              Yesterday's CORE4
            </h3>
            <p className="text-sm text-muted-foreground">
              {yesterdayDate?.toLocaleDateString('en-US', { 
                weekday: 'long', 
                month: 'short', 
                day: 'numeric' 
              })}
            </p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-2xl font-heading font-bold text-foreground">
            {completedCount}/4
          </p>
          <p className="text-xs text-muted-foreground">completed</p>
        </div>
      </div>
      {/* Completion Toggles */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {core4Areas?.map((area) => {
          const isCompleted = yesterdayCompletions?.[area?.key];
          
          return (
            <button
              key={area?.key}
              onClick={() => onYesterdayToggle(area?.key, !isCompleted)}
              className={`flex flex-col items-center p-4 rounded-lg border-2 transition-all duration-200 animate-spring ${
                isCompleted
                  ? `${area?.activeBg} border-transparent text-white shadow-gentle`
                  : `bg-background border-border hover:${area?.bgColor} hover:border-current ${area?.color}`
              }`}
            >
              <div className={`flex items-center justify-center w-12 h-12 rounded-lg mb-2 ${
                isCompleted ? 'bg-white/20' : area?.bgColor
              }`}>
                <Icon 
                  name={area?.icon} 
                  size={24} 
                  className={isCompleted ? 'text-white' : area?.color}
                />
              </div>
              <span className={`font-caption font-medium text-sm ${
                isCompleted ? 'text-white' : 'text-foreground'
              }`}>
                {area?.label}
              </span>
              {isCompleted && (
                <Icon name="Check" size={16} className="text-white mt-1" />
              )}
            </button>
          );
        })}
      </div>
      {/* Progress Summary */}
      <div className="mt-6 p-4 bg-muted/30 rounded-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Icon name="TrendingUp" size={16} className="text-muted-foreground" />
            <span className="text-sm text-muted-foreground">
              Yesterday's Progress
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <div className="w-20 h-2 bg-muted rounded-full overflow-hidden">
              <div 
                className="h-full bg-success transition-all duration-300"
                style={{ width: `${(completedCount / 4) * 100}%` }}
              />
            </div>
            <span className="text-sm font-mono text-muted-foreground">
              {Math.round((completedCount / 4) * 100)}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YesterdayCompletionSection;